console.clear();
var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

// Global vars
var pymChild = null;
var skipLabels = ["label", "values"];

var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min")
};

var { COLORS, classify, makeTranslate, formatStyle } = require("./lib/helpers");
const { teal5 } = require("./lib/helpers/colors");



var onWindowLoaded = function() {

  // formatData();
  render();

  window.addEventListener("resize", render);



  pym.then(child => {
      child.sendHeight();



    



      // child.onMessage("on-screen", function(bucket) {
      //     ANALYTICS.trackEvent("on-screen", bucket);
      // });
      // child.onMessage("scroll-depth", function(data) {
      //     data = JSON.parse(data);
      //     ANALYTICS.trackEvent("scroll-depth", data.percent, data.seconds);
      // });

      window.addEventListener("resize", () => child.sendHeight());
  });
}



var render = function() {

  var container = "#circle-legend";
  var element = document.querySelector(container);
  var width = element.offsetWidth;
  renderCircleLegend({
    container,
    width,
    people: PEOPLE
  });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }

}

var renderCircleLegend = function(config) {

  

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");



  var colorScale = d3
    .scaleOrdinal()
    .domain(
      Object.keys(config.people)
    )
    // .range([ '#51a09e','#aeb372', '#efc637','#eaa931', '#e38d2c','#bb6402']);
    // .range([COLORS.red3, COLORS.red5,"#FFFFFF", COLORS.blue5, COLORS.blue2 ]); //Original
        // .range([COLORS.teal, COLORS.red5,"#FFFFFF", COLORS.blue5, COLORS.blue1 ]); 
    // .range(["#762222", "#C89696","#FFFFFF", "#819CAB", "#113D59"]); // demuth
    // .range([COLORS.orange4, COLORS.orange6,"#FFFFFF", COLORS.teal6, COLORS.teal4]); // teal orange
    .range(["#7b3294", "#c2a5cf","#FFFFFF", "#a6dba0", "#008837"]); // barney
    // .range(['#7fcdbb','#41b6c4','#1d91c0','#225ea8','#253494','#081d58']);

  // Render the legend.
  var legend = containerElement
    .append("ul")
    .attr("class", "key")
    .selectAll("g")
    .data(colorScale.domain())
    .enter()
    .append("li")
    .attr("class", (d, i) => `key-item key-${i} ${classify(d)}`);

  legend
    .append("b").style("background-color", d=> colorScale(d));

  legend.append("label").text(d => config.people[d]);


}








// wait for images to load
window.onload = onWindowLoaded;
